import '@wix/ambassador-contacts-v4-contact/types';
import '@wix/ambassador-contacts-v4-contact/http';
import { RequestOptionsFactory } from '@wix/fe-essentials/http-client';

declare module '@wix/ambassador-contacts-v4-contact/types' {
  interface Contact {
    name?: string;
    image?: string;
    lastSeen?: Date;
    level?: string;
    subscription?: string;
    parentId?: string;
    breadcrumbs?: { id: string; name: string }[];
  }

  interface CreateContactRequest {
    name?: string;
    level?: string;
    lastSeen?: Date;
    createdDate?: Date;
  }
}

declare module '@wix/ambassador-contacts-v4-contact/http' {
  export interface MoveContactRequest {
    contactId?: string;
    insertAfterId?: string | null;
    parentId?: string;
    filters?: Record<string, any> | null;
  }

  export function moveContact(
    payload: MoveContactRequest,
  ): RequestOptionsFactory;
}
